import { takeEvery } from 'redux-saga/effects'
import { eventsConstants } from '../constants'
import { loadEventsSaga } from './events.sagas'

export function* watchEvents() {
  yield takeEvery(eventsConstants.EVENTS_INIT, loadEventsSaga)
}
